var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaiguang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 8.5,
    cy: 8,
    r: 4,
    fill: "#FFCF73",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4780"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 48",
    x1: 8.5,
    y1: 2.59375,
    x2: 8.5,
    y2: 0.34375,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 49",
    x1: 8.5,
    y1: 15.6563,
    x2: 8.5,
    y2: 13.4062,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4781"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 48_2",
    x1: 4.60494,
    y1: 4.34327,
    x2: 3.01395,
    y2: 2.75228,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 49_2",
    x1: 13.8418,
    y1: 13.5798,
    x2: 12.2508,
    y2: 11.9889,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4782"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 48_3",
    x1: 3.09375,
    y1: 8.5,
    x2: 0.84375,
    y2: 8.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 49_3",
    x1: 16.1563,
    y1: 8.5,
    x2: 13.9062,
    y2: 8.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4783"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 48_4",
    x1: 5.0308,
    y1: 12.1763,
    x2: 3.43981,
    y2: 13.7673,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 49_4",
    x1: 14.2676,
    y1: 2.93977,
    x2: 12.6766,
    y2: 4.53076,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaiguang);
export default __webpack_public_path__ + "static/media/caiguang.bcdea460624702789b1fbf352bb04376.svg";
export { ForwardRef as ReactComponent };